import { ReactElement } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

/** Cursor glyph with an "I" badge, denoting the IFC import selection tool. */
export const ImportCursorIcon = (props: SvgIconProps): ReactElement => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      {/* Cursor, scaled down and anchored top-left. */}
      <path d="m2 2 4.9 12 1.73-5.1L14.7 7.4z" />
      {/* Serif "I" for "Import". */}
      <text
        x="17.5"
        y="21"
        fontSize="12"
        fontWeight="700"
        fontFamily="serif"
        textAnchor="middle"
        fill="currentColor"
      >
        I
      </text>
    </SvgIcon>
  )
}
